<template>
  <div class="profile-data-view">
    <FloatingHeader
      title="Dados Pessoais"
      sbtitle="Gerencie seus dados"
      :showHeader="true"
      :hideSearch="true"
      :routeToBack="'profile'"
    ></FloatingHeader>

    <div class="inputs-container">
      <div class="input-text" v-for="(input, key) in profileFields" :key="key">
        <label :for="profileFields.id" v-text="input.display"
          :class="{ 'has-error': input.hasError, 'disabled': input.disabled, 'required': input.required }"></label>

          <input v-if="input.mask" :class="{ 'has-error': input.hasError, disabled: input.disabled }"
          :disabled="input.disabled" :type="input.type" v-model="values[input.id]" v-mask="input.mask"
          @input="validateInput(input.id)"  :placeholder="input.mask"  />

          <input v-else :type="input.type" :disabled="input.disabled"
          :class="{ 'has-error': input.hasError, 'disabled': input.disabled }" v-model="values[input.id]"
          @input="validateInput(input.id)" :placeholder="input.display" />
        <!-- Mensagem de erro abaixo do input -->
        <span v-if="input.hasError" class="error-message">{{ input.message }}</span>
      </div>
    </div>
    <div class="submit-button">
      <DefaultButton :text="'Atualizar'" :disabled="false" @defaultBtnClick="finish()" :large="true">
      </DefaultButton>
    </div>
  </div>
</template>
<script>
import FloatingHeader from '@/components/FloatingHeader.vue'
import DefaultButton from '@/components/buttons/DefaultButton.vue'
import Util from '@/assets/libs/util'
import { changeProfileData } from '@/assets/controllers/ConsumerController'
import { mapGetters } from 'vuex'

export default {
  name: 'ProfileDataView',
  components: {
    FloatingHeader,
    DefaultButton
  },
  data () {
    return {
      values: {
      },
      arrow_back: require('../../static/icons/arrow_back_white.svg')
    }
  },
  computed: {
    ...mapGetters(['profileFields', 'getUser'])
  },
  methods: {
    async validateInput (id, findCep = true) {
      if (id === 'name') {
        this.values[id] = this.values[id] ? this.values[id].replace(/( )+/g, ' ') : ''
        if (!this.values[id] || this.values[id].length < 3) {
          this.profileFields[0].hasError = true
        } else {
          this.profileFields[0].hasError = false
        }
      }
      if (id === 'email') {
        this.values[id] = this.values[id] ? this.values[id].replace(/\s/g, '') : ''
        if (!this.values[id] || (this.values[id] && this.values[id].length < 5)) {
          this.profileFields[1].hasError = true
        } else {
          this.profileFields[1].hasError = false
        }
      }
      if (id === 'cep') {
        if (this.values[id] && this.values[id].length === 9) {
          if (findCep) {
            await Util.findCep(this.values[id]).then((e) => {
              this.values.cidade = e?.localidade || ''
              this.values.bairro = e?.bairro || ''
              this.values.estado = e?.estado || ''
              this.values.logradouro = e?.logradouro || ''
              this.profileFields[4].hasError = false

              if (!e) {
                this.profileFields[4].hasError = true
                this.profileFields[4].message = 'CEP inválido'
              }
            }).catch(() => {
              this.profileFields[4].hasError = true
              this.profileFields[4].message = 'CEP inválido'
            })
          }
        } else {
          this.profileFields[4].hasError = true
          this.profileFields[4].message = 'CEP inválido'

          const fields = ['cidade', 'bairro', 'estado', 'logradouro']
          fields.forEach(f => {
            this.values[f] = ''
          })
        }
      }
      if (id === 'phone') {
        if (!this.values[id] || (this.values[id] && this.values[id].length < 15)) {
          this.profileFields[2].hasError = true
          this.profileFields[2].message = 'Telefone inválido'
        } else {
          this.profileFields[2].hasError = false
        }
      }
      const fields = ['cidade', 'bairro', 'estado', 'logradouro']
      if (fields.includes(id) && !this.values[id]) {
        this.profileFields.forEach(i => {
          if (i.id === id) {
            i.hasError = true
            i.message = 'Campo obrigatório'
          } else if (i.id === id && this.values[i.id]) {
            i.hasError = false
          }
        })
      }
    },
    capitalizeWords (str) {
      // coloca a primeira letra de cada palavra em maiúsculo, e o restante em minúsculo
      return str.split(' ').map(word =>
        word[0].toLocaleUpperCase('pt-BR') + word.slice(1).toLowerCase()
      ).join(' ')
    },
    async finish () {
      let hasError = false
      this.profileFields.forEach(async (e) => {
        await this.validateInput(e.id, false)
      })

      hasError = (this.profileFields.findIndex(e => e.hasError === true) !== -1)
      if (!hasError) {
        this.callUpdate()
      } else {
        Util.showWarningNotification({
          title: 'Atenção',
          text: 'Preencha todos os campos corretamente'
        })
      }
    },
    callUpdate () {
      const data = {
        name: this.values.name,
        email: this.values.email,
        cellphone: this.values.phone,
        address: {
          zipCode: this.values.cep,
          city: this.values.cidade,
          neighborhood: this.values.bairro,
          state: this.values.estado,
          street: this.values.logradouro,
          number: this.values.numero,
          complement: this.values.complemento
        }
      }

      changeProfileData(data).then((res) => {
        if (!res.error) {
          Util.showSuccessNotification({
            title: 'Sucesso',
            text: 'Dados atualizados com sucesso'
          })
        } else {
          Util.showErrorNotification({
            title: 'Erro',
            text: res?.message || 'Erro ao atualizar dados'
          })
        }
      }).catch((err) => {
        console.log(err)
        Util.showErrorNotification({
          title: 'Erro',
          text: 'Erro ao atualizar dados'
        })
      })
    },
    goBack () {
      this.$router.push('/profile')
    }
  },
  mounted () {
    this.profileFields.forEach((input, idx) => {
      input.hasError = false

      const fields = ['cidade', 'bairro', 'estado', 'logradouro']
      if (input.id === 'cpf' || input.id === 'email' || fields.includes(input.id)) {
        input.disabled = true
      }
    })

    const consumerData = this.getUser.consumer
    consumerData.city = this.capitalizeWords(consumerData.city)
    consumerData.neighborhood = this.capitalizeWords(consumerData.neighborhood)
    consumerData.state = this.capitalizeWords(consumerData.state)

    this.values = {
      name: consumerData.name,
      email: consumerData.email,
      phone: consumerData.cellphone,
      cpf: consumerData.cpf,
      cep: consumerData.zipCode,
      cidade: consumerData.city,
      bairro: consumerData.neighborhood,
      estado: consumerData.state,
      logradouro: consumerData.street,
      numero: consumerData.number,
      complemento: consumerData.complement
    }
  }
}
</script>
<style lang="less" scoped>
.profile-data-view {
  padding: 65px 20px 170px 20px;

  .required-fields {
    margin-top: 20px;
    font-size: 14px;
    color: #666;
    span {
      color: var(--primaryColor);
    }
  }
  .inputs-container {
    margin-top: 20px;
    .input-text {
      margin-bottom: 20px;
      label {
        font-size: 14px;
        color: #666;
        &.required::after {
          content: ' *';
          color: var(--primaryColor);
        }
        &.has-error {
          color: red;
        }
      }
      input {
        width: -webkit-fill-available;
        height: 40px;
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 0 10px;
        font-size: 14px;

        &.disabled {
          background-color: #f5f5f5;
        }

        &:focus {
          outline: none;
          border-color: var(--primaryColor);
        }
      }

      .error-message {
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }

  .submit-button {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    width: -webkit-fill-available;
    align-items: flex-start;
    justify-content: center;
    background: white;
    animation: upper-in 0.4s;
    padding: 35px 0 60px 0;
    filter: drop-shadow(2px 4px 4px black);

    button {
      color: white;
      background-color: var(--primaryColor);
      border: none;
      border-radius: 5px;
      height: 50px;
      width: 80vw;

      span {
        font-weight: lighter !important;
        font-size: 16px !important;
      }

      &.disabled {
        pointer-events: none;
        background-color: rgb(196, 196, 196);
      }
    }
  }
}
</style>
